import React from "reactn";
import LeftMessagingPanel from "./LeftMessagingPane/LeftMessagingPane";
import CenterMessagingPanel from "./CenterMessagingPane/CenterMessagingPane";
// import RightMessagingPanel from "./RightMessagingPane/RightMessagingPane";

class Messaging extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = { smallScreen: window.innerWidth < 800 };
    window.addEventListener("resize", () => {
      this.setState({ smallScreen: window.innerWidth < 800 });
    });
    this.setGlobal({
      pathway: [...this.global.pathway.slice(0, 1)],
      noShow: true
    });
  }

  async handleClick(contact) {
    await this.dispatch.ccChangeConversation(contact);
  }
  componentWillUnmount() {
    this.setGlobal({
      noShow: false
    });
  }
  render() {
    return (
      <div className="messages overflow-hidden">
        <div className="messagecenter d-flex">
          {this.state.smallScreen ? (
            !this.global.ccSelectedContact.conversationId && (
              <LeftMessagingPanel
                handleClick={this.handleClick}
                contacts={this.global.userPromise}
                selectedContact={this.global.ccSelectedContact}
              />
            )
          ) : (
            <LeftMessagingPanel
              handleClick={this.handleClick}
              contacts={this.global.userPromise}
              selectedContact={this.global.ccSelectedContact}
            />
          )}
          {this.global.ccSelectedContact.conversationId ? (
            <CenterMessagingPanel smallScreen={this.state.smallScreen} />
          ) : (
            ""
          )}
          {/* <RightMessagingPanel /> */}
        </div>
      </div>
    );
  }
}

export default Messaging;
